import * as t from "io-ts";

export const LocationsColumnBlockCMSData = t.interface({
    with_map: t.boolean,
});
